export const KNOWLEDGE_BASE = [
    // --- AIR (Vision & Trajectory) ---
    {
        id: 'fire-movement',
        element: 'air',
        title: 'What is a F.I. Number?',
        primer: "Financial Independence (FI) isn't a magic feeling; it's a math problem. Your FI Number is the amount of invested assets required to support your lifestyle indefinitely without working. The standard formula is your Annual Expenses × 25.",
        internalLink: 'dashboard',
        externalResource: {
            label: "The 4% Rule Explained (Investopedia)",
            url: "https://www.investopedia.com/terms/f/four-percent-rule.asp"
        }
    },
    {
        id: 'compound-interest',
        element: 'air',
        title: 'The Trajectory of Compounding',
        primer: "In your Vision graph, you'll see the line curve upward over time. This is 'interest on interest.' The first $100k is the hardest to save; after that, the money starts doing the heavy lifting for you.",
        internalLink: 'dashboard',
        externalResource: {
            label: "Visualizing Compound Interest",
            url: "https://www.investor.gov/financial-tools-calculators/calculators/compound-interest-calculator"
        }
    },

    // --- EARTH (Assets & Foundation) ---
    {
        id: 'asset-allocation',
        element: 'earth',
        title: 'Diversification: Building a Strong Foundation',
        primer: "Don't build your house on a single pillar. Asset Allocation is about spreading your money across different buckets (Stocks, Bonds, Cash, Real Estate) to minimize risk while capturing growth.",
        internalLink: 'allocation',
        externalResource: {
            label: "Asset Allocation 101 (Vanguard)",
            // H9 FIX 1: Updated Vanguard Link
            url: "https://investor.vanguard.com/investor-resources-education/portfolio-management/diversifying-your-portfolio"
        }
    },
    {
        id: 'tax-advantaged',
        element: 'earth',
        // H9 FIX 2: Updated Title
        title: 'Roth IRA vs Traditional IRA',
        primer: "Not all asset buckets are built the same. Pre-tax accounts (401k) lower your taxes today. Post-tax accounts (Roth) let you grow tax-free forever. A balanced Earth element often uses both.",
        internalLink: 'allocation',
        externalResource: {
            label: "IRA Account Comparison (NerdWallet)",
            // H9 FIX 2: Updated NerdWallet Link
            url: "https://www.nerdwallet.com/retirement/learn/roth-or-traditional-ira-account"
        }
    },

    // --- WATER (Flow & Reservoirs) ---
    {
        id: 'emergency-fund',
        element: 'water',
        title: 'The Emergency Reservoir',
        primer: "Before you fill your waterfalls or investment buckets, you need a full Reservoir. A standard safety net is 3–6 months of your 'Burn' number. This prevents you from tapping into debt when life happens.",
        internalLink: 'waterfall',
        externalResource: {
            label: "Emergency Fund Guide (CFPB)",
            url: "https://www.consumerfinance.gov/an-essential-guide-to-building-an-emergency-fund/"
        }
    },
    {
        id: 'sinking-funds',
        element: 'water',
        title: 'Sinking Funds: Smoothing the Flow',
        primer: "A Sinking Fund is saving for a known future expense (like Christmas or Car Insurance) a little bit every month. This turns a future 'emergency' into a manageable monthly bill.",
        internalLink: 'waterfall',
        externalResource: {
            label: "How Sinking Funds Work (Ramsey)",
            // H9 FIX 3: Updated Ramsey Link
            url: "https://www.ramseysolutions.com/saving/stop-the-panic-sinking-fund"
        }
    },

    // --- FIRE (Burn & Debt) ---
    {
        id: 'debt-strategies',
        element: 'fire',
        title: 'Avalanche vs. Snowball',
        primer: "Fire needs containment. The Avalanche method targets high interest rates first (Efficiency). The Snowball method targets small balances first (Behavior/Momentum). Both work; the best one is the one you stick to.",
        internalLink: 'debt',
        externalResource: {
            label: "Debt Payoff Strategies (Bankrate)",
            // H9 FIX 4: Updated Bankrate Link
            url: "https://www.bankrate.com/personal-finance/debt/how-to-pay-off-debt"
        }
    },
    {
        id: '50-30-20',
        element: 'fire',
        title: 'The 50/30/20 Rule',
        primer: "A simple framework to control the burn: 50% on Needs (Rent/Food), 30% on Wants (Dining/Hobby), and 20% on Savings/Debt repayment. Use the Tracker tab to see if your ratios align.",
        internalLink: 'tracker',
        externalResource: {
            label: "50/30/20 Rule Calculator",
            url: "https://www.nerdwallet.com/article/finance/nerdwallet-budget-calculator"
        }
    }
];